// src/utils/legendStyles.js

/**
 * Возвращает CSS background-image с повторяющимся линейным градиентом для штриховки.
 * Рендерится мгновенно без сетевых запросов на любом фоне.
 *
 * @param {string} hatch - 'horizontal' | 'vertical' | 'diagonal' | 'cross' | 'diagcross' | 'none'
 * @param {string} stroke - Цвет линий штриховки
 * @returns {string} CSS background-image значение
 */
export function getHatchBackground(hatch, stroke = 'rgba(0, 0, 0, 0.45)') {
    if (!hatch || hatch === 'none') {
        return 'none';
    }

    switch (hatch) {
        case 'horizontal':
            return `repeating-linear-gradient(0deg, ${stroke} 0px, ${stroke} 1.5px, transparent 1.5px, transparent 6px)`;
        case 'vertical':
            return `repeating-linear-gradient(90deg, ${stroke} 0px, ${stroke} 1.5px, transparent 1.5px, transparent 6px)`;
        case 'diagonal':
            return `repeating-linear-gradient(45deg, ${stroke} 0px, ${stroke} 1.5px, transparent 1.5px, transparent 6px)`;
        case 'cross':
            return `repeating-linear-gradient(0deg, ${stroke} 0px, ${stroke} 1.5px, transparent 1.5px, transparent 6px), repeating-linear-gradient(90deg, ${stroke} 0px, ${stroke} 1.5px, transparent 1.5px, transparent 6px)`;
        case 'diagcross':
            return `repeating-linear-gradient(45deg, ${stroke} 0px, ${stroke} 1.5px, transparent 1.5px, transparent 6px), repeating-linear-gradient(-45deg, ${stroke} 0px, ${stroke} 1.5px, transparent 1.5px, transparent 6px)`;
        default:
            return 'none';
    }
}

/**
 * Гармоничные палитры сочетающихся цветов по категориям
 */
export const COLOR_PALETTES = [
    {
        name: 'Природа и земля',
        colors: [
            { color: '#22c55e', name: 'Зелёный' },
            { color: '#16a34a', name: 'Лесной' },
            { color: '#84cc16', name: 'Лайм' },
            { color: '#10b981', name: 'Изумруд' },
            { color: '#14b8a6', name: 'Бирюза' },
            { color: '#059669', name: 'Хвоя' }
        ]
    },
    {
        name: 'Город и здания',
        colors: [
            { color: '#64748b', name: 'Сланец' },
            { color: '#475569', name: 'Графит' },
            { color: '#334155', name: 'Антрацит' },
            { color: '#ea580c', name: 'Кирпичный' },
            { color: '#c2410c', name: 'Терракот' },
            { color: '#78350f', name: 'Дерево' }
        ]
    },
    {
        name: 'Инфраструктура и акценты',
        colors: [
            { color: '#3b82f6', name: 'Синий' },
            { color: '#0284c7', name: 'Небесный' },
            { color: '#6366f1', name: 'Индиго' },
            { color: '#8b5cf6', name: 'Фиолетовый' },
            { color: '#f59e0b', name: 'Янтарный' },
            { color: '#ef4444', name: 'Красный' }
        ]
    },
    {
        name: 'Пастельные и светлые',
        colors: [
            { color: '#86efac', name: 'Мятный' },
            { color: '#93c5fd', name: 'Голубой' },
            { color: '#fde047', name: 'Песочный' },
            { color: '#fca5a5', name: 'Коралловый' },
            { color: '#d8b4fe', name: 'Лавандовый' },
            { color: '#cbd5e1', name: 'Светло-серый' }
        ]
    }
];

/**
 * Варианты штриховки с описанием и визуальным символом
 */
export const HATCH_OPTIONS = [
    { id: 'none', label: 'Сплошная', icon: '■' },
    { id: 'horizontal', label: 'Горизонтальная', icon: '▤' },
    { id: 'vertical', label: 'Вертикальная', icon: '▥' },
    { id: 'diagonal', label: 'Диагональная', icon: '▧' },
    { id: 'cross', label: 'Сетка', icon: '▦' },
    { id: 'diagcross', label: 'Диагональная сетка', icon: '▩' }
];

/**
 * Варианты типов линий
 */
export const LINE_TYPE_OPTIONS = [
    { id: 'solid', label: 'Сплошная', pattern: '───' },
    { id: 'dashed', label: 'Пунктирная', pattern: '---' },
    { id: 'dotted', label: 'Точечная', pattern: '···' }
];
